var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CycleTile',{attrs:{"title":_vm.title,"icon":_vm.icon,"summary":_vm.summary,"selected":_vm.selected,"is-vertical":_vm.isVertical,"is-imaged":_vm.isImaged,"image":_vm.image}},[_c('ScPlaceholder',{attrs:{"name":"jss-tile","rendering":_vm.rendering}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }